const React = require("react");
const {openPopupWindow} = require("../../../../../../../emitters/popup");
const changeProviderProvider = require("mn-utils/changeProviderProvider");
const {default: VisibilityOff} = require("@material-ui/icons/VisibilityOff");
const {default: Visibility} = require("@material-ui/icons/Visibility");
const {default: IconButton} = require("@material-ui/core/IconButton");
const Popup = require("../../../../../../dumb/Popup/C");
const {apiAdminAuctionManualStatusChange} = require("../../../../../../../api/admin/auctions");
const WrapperWithLoading = require("../../../../../../dumb/WrapperWithLoading");
const TextField = require("../../../../../../dumb/TextField/H");
const Checkbox = require('../../../../../../dumb/Checkbox/F');

module.exports = (props, update) => openPopupWindow((setPopupState, popup) => {
  const {
    close,
  } = popup;

  const handleProvider = changeProviderProvider(setPopupState);
  const handleChangePassword = handleProvider('password');
  const handleChangeHash = handleProvider('hash');
  const handleChangeFee = handleProvider('fee');
  const handleChangeSpreadFact = handleProvider('spreadFact');
  const handleChangePrimaryExchangeFee = handleProvider('primaryExchangeFee');
  const handleChangeSecondaryExchangeFee = handleProvider('secondaryExchangeFee');
  const handleChangeSpreadFinal = handleProvider('spreadFinal');

  return (stateOfPopup = {}) => {

    const {
      password,
      hash,
      fee,
      spreadFact,
      primaryExchangeFee,
      secondaryExchangeFee,
      runConversion = false,
      spreadFinal,
      showPassword,
      clicked
    } = stateOfPopup;

    const invalidPassword = !password;
    const invalidHash = !hash;

    const checkNumField = (val) => val && (isNaN(val) || Number(val) < 0);

    const invalidFee = checkNumField(fee);
    const invalidSpreadFact = checkNumField(spreadFact);
    const invalidPrimaryExchangeFee = checkNumField(primaryExchangeFee);
    const invalidSecondaryExchangeFee = checkNumField(secondaryExchangeFee);
    const invalidSpreadFinal = checkNumField(spreadFinal);

    const formHasErrors = invalidPassword
      || invalidHash
      || invalidFee
      || invalidSpreadFact
      || invalidPrimaryExchangeFee
      || invalidSecondaryExchangeFee
      || invalidSpreadFinal;

    const numberHelperText = 'Must be a positive number';

    const VisibilityIcon = showPassword
      ? VisibilityOff
      : Visibility;

    const InputPropsEUR = {
      endAdornment: (
        <span
          className="rlv sl8 pt14 pr10 pb17 c8B8D93"
        >
          EUR
        </span>
      ),
    }

    const disableCommas = true;

    const fields = [
      {
        label: 'Fee',
        placeholder: '0',
        value: fee,
        onChange: handleChangeFee,
        error: invalidFee,
        helperText: numberHelperText,
        InputProps: InputPropsEUR,
        disableCommas,
      },
      {
        label: 'Spread Fact',
        placeholder: '0',
        value: spreadFact,
        onChange: handleChangeSpreadFact,
        error: invalidSpreadFact,
        helperText: numberHelperText,
        InputProps: InputPropsEUR,
        disableCommas,
      },
      {
        label: 'Primary Exchange Fee',
        placeholder: '0',
        value: primaryExchangeFee,
        onChange: handleChangePrimaryExchangeFee,
        error: invalidPrimaryExchangeFee,
        helperText: numberHelperText,
        InputProps: InputPropsEUR,
        disableCommas,
      },
      {
        label: 'Secondary Exchange Fee',
        placeholder: '0',
        value: secondaryExchangeFee,
        onChange: handleChangeSecondaryExchangeFee,
        error: invalidSecondaryExchangeFee,
        helperText: numberHelperText,
        InputProps: InputPropsEUR,
        disableCommas,
      },
      {
        label: 'Spread Final',
        placeholder: '0',
        value: spreadFinal,
        onChange: handleChangeSpreadFinal,
        error: invalidSpreadFinal,
        helperText: numberHelperText,
        InputProps: InputPropsEUR,
        disableCommas,
      },
      {
        label: 'Hash*',
        value: hash,
        onChange: handleChangeHash,
        error: invalidHash,
        InputProps: {
          autoComplete: 'off'
        }
      },
      {
        label: 'Password *',
        type: showPassword ? 'text' : 'password',
        value: password,
        onChange: handleChangePassword,
        error: invalidPassword,
        InputProps: {
          autoComplete: 'new-password',
          endAdornment: (
            <IconButton
              className="rlv sl8 mv-5*2"
              onClick={() => {
                setPopupState({
                  showPassword: !showPassword,
                });
              }}
            >
              <VisibilityIcon
                className="c0C"
              />
            </IconButton>
          ),
        }
      },
      {
        component: Checkbox,
        className: 'pl88',
        checked: runConversion,
        label: 'Manual conversion',
        onChange: (runConversion) => setPopupState({runConversion}),
        black: true
      }
    ]

    return (
      <Popup
        caption={(
          <div>
            <span className="cRed">Manual Acceptance</span>
          </div>
        )}
        onCancel={close}
        onSave={() => {
          if (formHasErrors) {
            setPopupState({
              clicked: true
            });
            return;
          }

          setPopupState({
            loading: true,
          });

          const auctionId = props.id;

          const handleNumResult = (val) => val ? Number(val) : 0;

          apiAdminAuctionManualStatusChange({
            password,
            auction_id: auctionId,
            hash,

            fee: handleNumResult(fee),
            spread_fact: handleNumResult(spreadFact),
            primary_exchange_fee: handleNumResult(primaryExchangeFee),
            secondary_exchange_fee: handleNumResult(secondaryExchangeFee),
            spread_final: handleNumResult(spreadFinal),
            run_conversion: runConversion
          }).then(update)
            .then(close)
            .catch((err) => {
              console.log('----ERRR!', err);
              setPopupState({
                loading: false,
                clicked: true
              });
            });
        }}
        // disabled
      >
        <p className="wmax910 mv20">
          Please enter the admin password to make a manual acceptance
        </p>
        <WrapperWithLoading
          loading={stateOfPopup.loading}
        >
          <div className="wmax910">
            {fields.map(({component: C = TextField, className, error, ...rest}, i) => (
              <C
                key={i}
                className={`mt20 wmax472` + (className ? ` ${className}` : '')}
                {...rest}
                error={clicked && error}
              />
            ))}
          </div>
        </WrapperWithLoading>
      </Popup>
    )
  }
})
